import type { Components } from '@mui/material/styles';

export default function MuiMobileStepper(): Components['MuiMobileStepper'] {
  return {};
}
